<template>
  <el-dialog
    :title="model.id ? `编辑订单` : `添加订单`"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="单号" prop="number">
        <el-input v-model="model.number"></el-input>
      </el-form-item>
      <el-form-item label="销售">
        <el-input v-model="model.saler"></el-input>
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input v-model="model.customer_name"></el-input>
      </el-form-item>
      <el-form-item label="客户联系人">
        <el-input v-model="model.customer_contact"></el-input>
      </el-form-item>
      <el-form-item label="客户联系电话">
        <el-input v-model="model.customer_contact_phone"></el-input>
      </el-form-item>
      <el-form-item label="销售钻头" v-if="visible" prop="drill_ids">
        <DrillSelect v-model="model.drill_ids"></DrillSelect>
      </el-form-item>
      <el-form-item label="订单金额">
        <el-input-number
          class="long text-left"
          v-model="model.total_price"
          :precision="2"
          :controls="false"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>

      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { saleOrderNew, saleOrderUpdate } from '@/service/getData'
import DrillSelect from '@/components/select/drill_multiple_select'

export default {
  components: {
    DrillSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        number: [{ required: true, message: '请填写编号', trigger: 'blur' }],
        drill_ids: [
          { required: true, message: '请选择钻头', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          data.total_price = parseFloat(data.total_price)
          if (this.model.id > 0) {
            let res = await saleOrderUpdate(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          } else {
            let res = await saleOrderNew(data)
            if (res.code == 0) {
              this.$emit('callback', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>